import styled from 'styled-components';

import { fontSize, FontSizes, FontWeights, maxWidth, minWidth, Text, units } from '@calm-web/design-system';

export const Body = styled(Text).attrs({
	color: 'offBlack',
	size: FontSizes.base,
	weight: FontWeights.Light,
	el: 'p',
})`
	margin: 0 auto;
	text-align: center;
	line-height: 140%;
	font-style: normal;
	width: 100%;
	max-width: 750px;
	padding: 0 ${units(2)};
	${minWidth('desktop')} {
		${fontSize(FontSizes.lg)}
		padding: 0;
	}
`;

export const Splash = styled.div`
	background-image: url(/_n/images/book/benefits-splash-desktop.webp);
	background-repeat: no-repeat;
	background-position: 50%;
	background-size: 1524px 757px;
	width: 1524px;
	height: 757px;
	margin: 40px auto 120px;

	${maxWidth('desktopLarge')} {
		transform: translate(-50%);
		position: relative;
		left: 50%;
	}
	${maxWidth('mobileLarge')} {
		background-image: url(/_n/images/book/benefits-splash-mobile.webp);
		background-size: 490px 520px;
		width: 490px;
		height: 520px;
	}
`;
